export enum FAQ_PERMISSIONS {
  FAQ_VIEW = 'FAQ_VIEW',
  FAQ_WRITE = 'FAQ_WRITE',
}
